import $ from 'swiper/esm/utils/dom';

let common = require('./modules/common');
const axios = require('axios');

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

common.init();

$('.page').on('click', '#more', function (e) {
    e.preventDefault();
    axios({
        responseType: 'json',
        url: $(this).data('next-page'),
        method: 'get'
    }).then(function (response) {
        document.getElementById('pagination').remove();
        $('#news').append(response.data.html);
    });
});